"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOADER_SIZE_LIST = void 0;
// eslint-disable-next-line import/prefer-default-export
const LOADER_SIZE_LIST = {
  small: 16,
  medium: 32,
  large: 48
};
exports.LOADER_SIZE_LIST = LOADER_SIZE_LIST;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJMT0FERVJfU0laRV9MSVNUIiwic21hbGwiLCJtZWRpdW0iLCJsYXJnZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0xvYWRlci9Mb2FkZXIuY29uc3RzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBpbXBvcnQvcHJlZmVyLWRlZmF1bHQtZXhwb3J0XG5leHBvcnQgY29uc3QgTE9BREVSX1NJWkVfTElTVCA9IHtcbiAgc21hbGw6IDE2LFxuICBtZWRpdW06IDMyLFxuICBsYXJnZTogNDgsXG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBO0FBQ08sTUFBTUEsZ0JBQWdCLEdBQUc7RUFDOUJDLEtBQUssRUFBRSxFQUR1QjtFQUU5QkMsTUFBTSxFQUFFLEVBRnNCO0VBRzlCQyxLQUFLLEVBQUU7QUFIdUIsQ0FBekIifQ==